// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useAuth, AuthProvider } from './context/AuthContext'; // ✅
import ProtectedAdminRoute from './components/ProtectedAdminRoute'; // ✅ NY

import StartScreen from './pages/StartScreen';
import CreateEssensScreen from './pages/CreateEssens/CreateEssensScreen';
import Summary from './pages/CreateEssens/Summary';
import MyEssenceScreen from './pages/MyEssence/MyEssence';
import AllEssensScreen from './pages/AllEssens/AllEssensScreen';
import AdminScreen from './pages/Admin/AdminScreen';
import AuthDebugScreen from './pages/AuthDebug/AuthDebugScreen';
import DebugEssensScreen from './pages/AuthDebug/DebugEssensScreen';
import LoginScreen from './pages/Auth/LoginScreen';
import UserLoginScreen from './pages/Auth/UserLoginScreen'; // ✅ NY
import NoteScreen from './components/NoteScreen'; // ✅ NY
import EssensChatScreen from './pages/EssensChatScreen'; // ✅ Chat

import Navbar from './components/Navbar';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isStartPage = location.pathname === '/';
  const { user, loading } = useAuth(); // ✅ lagt til loading

  if (loading) {
    return (
      <div className="text-white text-center mt-20">
        🔄 Laster inn brukerdata...
      </div>
    );
  }

  return (
    <div>
      {!isStartPage && user && <Navbar />}
      <Routes>
        <Route path="/" element={<StartScreen />} />
        <Route path="/create-essens" element={<CreateEssensScreen />} />
        <Route path="/summary" element={<Summary />} />
        <Route path="/myessence" element={<MyEssenceScreen />} />
        <Route path="/all" element={<AllEssensScreen />} />
        <Route path="/notes" element={<NoteScreen user={user} />} />
        <Route path="/chat" element={<EssensChatScreen />} /> {/* ✅ NY */}
        <Route path="/user-login" element={<UserLoginScreen />} />
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <AdminScreen />
            </ProtectedAdminRoute>
          }
        />
        <Route path="/auth-debug" element={<AuthDebugScreen />} />
        <Route path="/debug-essens" element={<DebugEssensScreen />} />
        <Route path="/admin-login" element={<LoginScreen />} /> {/* ✅ Endret */}
        <Route path="/login" element={<Navigate to="/admin-login" />} /> {/* ✅ Valgfri redirect */}
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider> {/* ✅ Nå er hele appen omringet av AuthContext */}
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
